var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4884 6.65406C27.4759 7.64154 27.4759 9.24255 26.4884 10.23C25.501 11.2175 23.9 11.2175 22.9125 10.23C21.925 9.24255 21.925 7.64154 22.9125 6.65406C23.9 5.66658 25.501 5.66658 26.4884 6.65406",
    stroke: "#222222",
    strokeWidth: 1.87488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2521 2.14038C19.7726 3.66088 19.7726 6.12612 18.2521 7.64663C16.7316 9.16714 14.2664 9.16714 12.7458 7.64663C11.2253 6.12613 11.2253 3.6609 12.7458 2.14038C14.2664 0.619874 16.7316 0.619874 18.2521 2.14038",
    stroke: "#222222",
    strokeWidth: 1.87488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08513 6.65406C9.0726 7.64154 9.0726 9.24255 8.08513 10.23C7.09765 11.2175 5.49664 11.2175 4.50916 10.23C3.52169 9.24255 3.52169 7.64154 4.50916 6.65406C5.49664 5.66658 7.09765 5.66658 8.08513 6.65406",
    stroke: "#222222",
    strokeWidth: 1.87488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.249 18.4989V17.129C29.249 15.4028 27.8504 14.0042 26.1242 14.0042H25.123",
    stroke: "#222222",
    strokeWidth: 1.87488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 18.4989V17.129C1.75 15.4028 3.14866 14.0042 4.8748 14.0042H5.87599",
    stroke: "#222222",
    strokeWidth: 1.87488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1721 18.4989V16.4978C22.1721 14.0817 20.2135 12.123 17.7974 12.123H13.1989C10.7828 12.123 8.82422 14.0817 8.82422 16.4978V18.4989",
    stroke: "#222222",
    strokeWidth: 1.87488,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSessions);
export default __webpack_public_path__ + "static/media/Group-Sessions.c2d24ac1bdf9c0c2e290a4d93b72efb4.svg";
export { ForwardRef as ReactComponent };